import type { FC } from 'react'

import SignUpView from 'views/SignUp'

import data from '../../data/signUp/data'
import { audienceCarouselLogos, AudienceTestimonialLogo, AudienceImage } from '../../data/signUp/components'

const SignUp: FC = () => {
  const { audience } = data
  return (
    <SignUpView
      {...data}
      logos={audienceCarouselLogos(audience)}
      image={<AudienceImage audience={audience} />}
      testimonialLogo={<AudienceTestimonialLogo audience={audience} />}
    />
  )
}

export default SignUp
